// frontend/src/components/event/LiveBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const TYPE_LABELS = {
  webinar: { de: "Webinar", en: "Webinar" },
  workshop: { de: "Workshop", en: "Workshop" },
  meetup: { de: "Meetup", en: "Meetup" },
  course: { de: "Kurs", en: "Course" },
  conference: { de: "Konferenz", en: "Conference" },
  talk: { de: "Vortrag", en: "Talk" },
};

const LiveBadge = ({ type, size = "md" }) => {
  const { t } = useLanguage();

  const label = TYPE_LABELS[type] || TYPE_LABELS.webinar;

  // Outer badge matches contract badge / LocationBadge sizing exactly
  const sizeClasses = {
    sm: "text-xs pl-1 pr-2 py-1",
    md: "text-sm pl-1 pr-3 py-1",
    lg: "text-base pl-1.5 pr-3 py-1.5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-bold bg-[#002855] text-white ${sizeClasses[size]}`}
    >
      <span className="bg-red-600 text-white px-[3px] py-0.5 rounded-sm leading-none">
        Live
      </span>
      <span className="leading-none">{t(label)}</span>
    </span>
  );
};

export default LiveBadge;
